import jQuery from 'jquery'

export function sendRequestToServer (path, method) {
  let p = new Promise((resolve, reject) => {
    let methodFunc = method === 'GET' ? jQuery.get : jQuery.post
    methodFunc(path, (answer, status) => {
      if (status !== 'success') reject('Error while connecting to server in sendRequestToServer')
      else {
        var ans = JSON.parse(answer)
        if ('stack' in ans) {
          if (ans.message === 'ERROR: unauthorized') window.location = '/login'
          else reject(ans.message)
        }
        else resolve(ans)
      }
    })
  })
  return p
}

export function getAccountParams () {
  return sendRequestToServer('/getAccountParams', 'GET')
}

export function runServiceCommand (cmd) {
  return sendRequestToServer('/service?' + cmd, 'POST')
}

export function getParameterByName (name) {
  var url = window.location.href
  name = name.replace(/[[\]]/g, '\\$&')
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
  var results = regex.exec(url)
  if (!results) return '' // null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}



// WEBPACK FOOTER //
// ./src/lib/utils.js